<template>
  <div class="official-profile-card">
    <div
      v-if="official.photo"
      class="official-profile-card__image--wrapper mb-3">
      <img
        :src="official.photo"
        class="official-profile-card__image">
    </div>

    <div 
      v-if="official.label" 
      class="official-profile-card__label-wrapper">
      <div class="official-profile-card__label">{{ official.label }}</div>
    </div>

    <div class="official-profile-card__title mb-2">{{ official.title }}</div>
  
    <div class="official-profile-card__name-and-party">
      <span class="official-profile-card__name mr-2">{{ official.name }}</span>
      <span 
        v-if="official.party"
        class="official-profile-card__party-label"
      >
        <party-label :party-name="official.party"/>
      </span>
    </div>

    <div class="official-profile-card__socials mt-3">
      <social-icon
        v-for="{ siteName, link } in socials"
        :class="'official-profile-card__social--' + siteName"
        :key="siteName"
        :site="siteName"
        :link="link"/>
    </div>

    <div class="official-profile-card__contact mt-4">
      <div
        v-if="official.email"
        class="official-profile-card__email"
      >
        {{ $t("cac.app.email") }}: {{ official.email }}
      </div>
      <div
        v-if="official.phone"
        class="official-profile-card__phone"
      >
        {{ $t("cac.app.phone") }}: {{ official.phone }}
      </div>
      <div
        v-if="official.website"
        class="official-profile-card__website"
      >
        {{ $t("cac.app.website") }}: 
        <a 
          :href="official.website" 
          target="_blank"
        >
          {{ official.website }}
        </a>
      </div>
    </div>
    <!-- 
      We don't ever have address data right now

      <div class="col-md-5 official-profile-card__contact">
        <div class="official-profile-card__address">{{ official.address }}</div>
      </div> 
    -->
  </div>
</template>

<script>
import PartyLabel from "./OfficialProfileCard/PartyLabel.vue";
import SocialIcon from "./OfficialProfileCard/SocialIcon.vue";

export default {
  name: "OfficialProfileCard",
  components: {
    PartyLabel,
    SocialIcon
  },
  props: {
    official: {
      type: Object,
      required: true
    }
  },
  computed: {
    socials() {
      const { socials = {} } = this.official;

      return Object.entries(socials)
        .map(([siteName, data]) => {
          const link = typeof data === "string" ? data : data.url;
          if (!link) return false;

          return {
            siteName,
            link
          };
        })
        .filter(item => item !== false);
    }
  }
};
</script>
